<template>
  <div class="zoom-btns-container">
    <div class="zoom-btn top-radius" @click="zoom(1)">
      <fa :icon="['fas', 'plus']" size="sm"/>
    </div>
    <div class="zoom-btn bottom-radius" @click="zoom(-1)">
      <fa :icon="['fas', 'minus']" size="sm"/>
    </div>
  </div>
</template>

<style>
.zoom-btns-container {
  display: inline-flex;
  flex-direction: column;
  width: 2.25rem;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(6, 60, 109, 0.22);
  overflow: hidden;
}

.zoom-btns-container .zoom-btn {
  height: 2.25rem;
  width: 2.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #063c6d;
  background: #ffffff;
  font-size: 0.8125rem;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

/* Divider between the + and − buttons */
.zoom-btns-container .zoom-btn.top-radius {
  border-bottom: 1px solid rgba(6, 60, 109, 0.12);
}

.zoom-btns-container .zoom-btn.top-radius {
  border-radius: 10px 10px 0 0;
}

.zoom-btns-container .zoom-btn.bottom-radius {
  border-radius: 0 0 10px 10px;
}

.zoom-btns-container .zoom-btn:hover {
  background: rgba(6, 60, 109, 0.08);
  color: #0a5ca3;
}

.zoom-btns-container .zoom-btn:active {
  background: rgba(6, 60, 109, 0.16);
}
</style>

<script>
export default {
  name: "ZoomWidget",
  props: ['map'],
  methods: {
    zoom(delta) {
      if (!this.map) return;
      const view = this.map.getView();
      const zoom = view.getZoom();

      view.animate({
        zoom: zoom + delta,
        duration: 250
      });
    },

    handleKeyZoom(event) {
      // Prevent triggering if user is typing in an input or textarea
      const activeElement = document.activeElement;
      if (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA') return;

      if (!this.map) return;
      const view = this.map.getView();
      const zoom = view.getZoom();

      if (event.key === '+' || event.key === '=') {
        view.animate({ zoom: zoom + 1, duration: 250 });
      } else if (event.key === '-') {
        view.animate({ zoom: zoom - 1, duration: 250 });
      }
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyZoom);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyZoom);
  }
}
</script>